import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import convertSuggestionToPersonaType from 'owa-substrate-people-suggestions/lib/utils/convertSuggestionToPersonaType';

const DEFAULT_MAX_RESULTS = 20;

export default action('processSubstrateSuggestionsResponse')(
    function processSubstrateSuggestionsResponse(
        resultList: FindRecipientPersonaType[],
        resp: SubstrateSearchSuggestionsResponse,
        appendResults: boolean,
        maxResults?: number,
        returnMaskedRecipients?: boolean
    ) {
        if (!resp || !resp.Groups) {
            throw new Error('Response groups should not be null');
        } else {
            let personaTypeSet: FindRecipientPersonaType[] = [];

            maxResults = maxResults ? maxResults : DEFAULT_MAX_RESULTS;
            maxResults = appendResults ? maxResults - resultList.length : maxResults;

            for (const group of resp.Groups) {
                if (group.Type === 'People') {
                    group.Suggestions.forEach(suggestion => {
                        if (personaTypeSet.length < maxResults) {
                            const personaType = convertSuggestionToPersonaType(
                                suggestion,
                                returnMaskedRecipients
                            );
                            personaType && personaTypeSet.push(personaType);
                        }
                    });
                    break;
                }
            }

            if (appendResults) {
                resultList.push(...personaTypeSet);
            } else {
                resultList.splice(0, resultList.length, ...personaTypeSet);
            }
        }
    }
);
